import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/PolicyPages.css";

const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const resp = await fetch("/api/subscription-plans");
        const data = await resp.json();
        setPlans(data);
      } catch (err) {
        console.error("Failed to load plans:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Subscription Pricing</h1>
        <p className="policy-updated">Effective as of February 2026</p>

        <section className="policy-section">
          <h2>Our Plans</h2>
          <p>VyralNews offers flexible subscription plans that give you unlimited access to all articles, in-depth analysis, and exclusive content across every category.</p>

          {loading ? (
            <p>Loading plans...</p>
          ) : (
            <div className="pricing-cards">
              {plans.map((plan) => {
                const hasSpecial = plan.special_price_cents && plan.special_price_cents > 0;
                return (
                  <div key={plan.id} className="pricing-card">
                    {hasSpecial && <div className="pricing-badge">{plan.special_label || "Special Offer"}</div>}
                    <h3>{plan.name}</h3>
                    <div className="pricing-amount">
                      {hasSpecial && <span className="pricing-original">{formatPrice(plan.price_cents)}</span>}
                      <span className="pricing-current">{formatPrice(hasSpecial ? plan.special_price_cents : plan.price_cents)}</span>
                      <span className="pricing-interval">/{plan.interval_label.toLowerCase()}</span>
                    </div>
                    <ul className="pricing-features">
                      <li>Unlimited article access</li>
                      <li>Full content and images</li>
                      <li>All categories included</li>
                      <li>Cancel anytime</li>
                    </ul>
                  </div>
                );
              })}
            </div>
          )}
        </section>

        <section className="policy-section">
          <h2>What's Included</h2>
          <p>Every VyralNews subscription includes:</p>
          <ul>
            <li><strong>Unlimited Access</strong> - Read every article across all categories: Politics, World, Business, Health, Technology, Entertainment, Sports, and Local news.</li>
            <li><strong>Full Article Content</strong> - Access complete articles with images, not just headlines and excerpts.</li>
            <li><strong>No Ads</strong> - Enjoy a clean reading experience without intrusive advertising.</li>
            <li><strong>Cancel Anytime</strong> - You can cancel your subscription at any time from your Profile page. Your access continues until the end of your current billing period.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Billing</h2>
          <p>Subscriptions are billed automatically at the start of each billing cycle. Your payment method on file with Stripe will be charged on your renewal date. You can view your billing history and next billing date on your <Link to="/user/profile">Profile page</Link>.</p>
        </section>

        <section className="policy-section">
          <h2>Questions?</h2>
          <p>If you have questions about pricing or your subscription, please contact us at <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a>.</p>
        </section>

        <div className="policy-links">
          <Link to="/payment-policy">Payment Policy</Link>
          <Link to="/refund-policy">Refund Policy</Link>
          <Link to="/signup">Sign Up</Link>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
